import { useTranslation } from "next-i18next"

const useCustomerSupporti18n = authorData => {
  const { t } = useTranslation()
  const i18n = {
    verifyMobile:
      authorData?.mobileDescriptionPlaceHolder ??
      t("kf.customerSupport.verifyMobile"),
    mobileVerified:
      authorData?.mobilerNumberOtpDescription ??
      t("kf.customerSupport.mobileVerified"),
    serviceTab: t("kf.customerSupport.label.serviceTab"),
    feedbackTab: t("kf.customerSupport.label.feedbackTab"),
    mainTitle:
      authorData?.mainTabTitle ?? t("kf.customerSupport.label.mainTitle"),
    mobile:
      authorData?.mobilePlaceholder ?? t("kf.customerSupport.label.mobile"),
    requiredInfoText: t("kf.customerSupport.label.requiredFields"),
    fname: t("kf.customerSupport.label.fname"),
    lname: t("kf.customerSupport.label.lname"),
    email: t("kf.customerSupport.label.email"),
    cemail: t("kf.customerSupport.label.cemail"),
    address: t("kf.customerSupport.label.address"),
    landmark: t("kf.customerSupport.label.landmark"),
    pincode: t("kf.customerSupport.label.pincode"),
    state: t("kf.customerSupport.label.state"),
    city: t("kf.customerSupport.label.city"),
    alternateNumber: t("kf.customerSupport.label.alternateNumber"),
    dateOfInvoice: t("kf.customerSupport.label.dateOfInvoice"),
    serviceRequest: t("kf.customerSupport.label.serviceRequest"),
    productDetails: t("kf.customerSupport.label.productDetails"),
    reportIssues: t("kf.customerSupport.label.reportIssues"),
    submit: t("kf.customerSupport.label.submit"),
    cancel: t("kf.customerSupport.label.cancel"),
    verify: t("kf.customerSupport.label.verify"),
    backToCustomerSupport:
      authorData?.ctaLabel ??
      t("kf.customerSupport.label.backToCustomerSupport"),
    messageMobile: t("kf.customerSupport.message.mobile"),
    messageHeaderSuccess:
      authorData?.successTitle ?? t("kf.customerSupport.message.headerSuccess"),
    messageDescriptionSuccess:
      authorData?.successDescription ??
      t("kf.customerSupport.message.descriptionSuccess"),
    messageVerifyPhone: t("kf.customerSupport.message.verifyPhone"),
    errorMobile: t("kf.customerSupport.error.mobile"),
    errorFname: t("kf.customerSupport.error.fname"),
    errorLname: t("kf.customerSupport.error.lname"),
    errorEmail: t("kf.customerSupport.error.email"),
    errorAddress: t("kf.customerSupport.error.address"),
    errorPincode: t("kf.customerSupport.error.pincode"),
    pincodeValid: t("kf.customerSupport.error.pincodeValid"),
    pincodeNotValid: t("kf.customerSupport.error.pincodeNotValid"),
    errorState: t("kf.customerSupport.error.state"),
    errorCity: t("kf.customerSupport.error.city"),
    errorServiceRequest: t("kf.customerSupport.error.serviveRequest"),
    errorProductDetails: t("kf.customerSupport.error.productDetails"),
    errorReportIssue: t("kf.customerSupport.error.reportIssue"),
    fnameError: t("kf.contactus.error.fnameError"),
    lnameError: t("kf.contactus.error.lnameError"),
    noEmailError: t("kf.contactus.error.noEmailError"),
    validEmail: t("kf.contactus.error.validEmail"),
    confirmEmailError: t("kf.contactus.error.confirmEmailError"),
    emailMatchError: t("kf.contactus.error.emailMatchError"),
    noCompanyError: t("kf.contactus.error.noCompanyError"),
    businessTypeError: t("kf.contactus.error.businessTypeError"),
    subTypeError: t("kf.contactus.error.subTypeError"),
    addressError: t("kf.contactus.error.addressError"),
    cityError: t("kf.contactus.error.cityError"),
    stateError: t("kf.contactus.error.stateError"),
    zipcodeError: t("kf.contactus.error.zipcodeError"),
    validZipcode: t("kf.contactus.error.validZipcode"),
    cityStateZipMismatchError: t(
      "kf.contactus.error.cityStateZipMismatchError"
    ),
    countryError: t("kf.contactus.error.countryError"),
    validPhone: t("kf.contactus.error.validPhone"),
    noPhoneError: t("kf.contactus.error.noPhoneError"),
    ratingQuestion:
      authorData?.ratingQuestion ?? t("kf.customerSupport.ratingQuestion"),
    selectReasons:
      authorData.selectReasons ?? t("kf.customerSupport.selectReasons"),
    requestID: t("kf.customerSupport.requestID"),
    registeredNumber: t("kf.customerSupport.registeredNumber"),
    selectRating: t("kf.customerSupport.selectRating"),
    labelAfterClick: t("kf.customerSupport.labelAfterClick"),
    comments: t("kf.customerSupport.comments"),
    technicianFeedbackQuestion:
      authorData?.technicianFeedbackQuestion ??
      t("kf.customerSupport.technicianFeedbackQuestion"),
    selectOption: t("kf.customerSupport.selectOption"),
    anyOtherRemarks: t("kf.customerSupport.anyOtherRemarks"),
    submit: t("kf.contactus.label.submitButton"),
    changeNumber: t("kf.customerSupport.label.changeNumber"),
    errorRequestId: t("kf.customerSupport.error.requestID"),
    errorMobileNumber: t("kf.customerSupport.error.mobileNumber"),
    errorRating: t("kf.customerSupport.error.rating"),
    errorSelectOption: t("kf.customerSupport.error.selectOption"),
    errorSelectReasons: t("kf.customerSupport.error.selectReasons"),
    errorComments: t("kf.customerSupport.error.comments"),
    feedbackMessageSuccess: t("kf.customerSupport.feedbackMessageSuccess"),
    errorValidMobileNumber: t("kf.customerSupport.error.validMobileNumber"),
    bannerConfirmationText: authorData?.bannerConfirmationText ?? "",
    feedbackBannerConfirmation: authorData?.feedbackBannerConfirmation ?? "",
  }

  return i18n
}

export default useCustomerSupporti18n
